import { render, staticRenderFns } from "./UpdateConfirmationModal.vue?vue&type=template&id=5a3c6dce"
import script from "./UpdateConfirmationModal.vue?vue&type=script&lang=js"
export * from "./UpdateConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports